import dayjs from 'dayjs';

export const ALLOW_LOCATION_HINT = 'Tap Allow to see fisheries near you';

export const getWhereSummary = ({ selectedLocation, typedPlace }) => {
  if (typedPlace) {
    return typedPlace;
  }
  if (!selectedLocation || selectedLocation.type === 'nearby') {
    return 'Near me';
  }
  return selectedLocation.address.split(',')[0];
};

const toFlexibleMonth = (date) => ({ date, id: date.format('MMMM-YYYY') });

// "Any date" is a flexible search over this month and next: lakes with space
// on any day show up, and Book Now leaves the date for the visitor to pick.
export const getAnyDateSelection = (today = dayjs()) => {
  const thisMonth = today.startOf('month');
  return {
    dateMethod: 'Flexible Search',
    selectedSession: null,
    selectedMonths: [thisMonth, thisMonth.add(1, 'month')].map(toFlexibleMonth),
  };
};
